import {
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  Paper,
} from "@mui/material";
import { useTranslation } from "react-i18next";
import { ResponsiveTable } from "@floriday/floriday-ui";
import { useProductDetails } from "../../hooks/useProductDetails";
import type { EntityNamingDto } from "../../../../RoyalFloraHolland.Aap.Services.Api.Web.Kiota/Typescript/Api/models/index";
import { formatDate, formatDateTime } from "../../utils/dateFormat";

export function ProductNamesTab({ productId }: { productId: string }) {
  const { t } = useTranslation();
  const { data: productDetails, isLoading } = useProductDetails(productId);
  const entityNamings: EntityNamingDto[] = (productDetails?.entityNamings ??
    []) as EntityNamingDto[];

  if (isLoading) {
    return null;
  }

  return (
    <TableContainer component={Paper} variant="outlined" sx={{ p: 0 }}>
      <ResponsiveTable striped>
        <TableHead>
          <TableRow>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productNames.language")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productNames.type")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productNames.name")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productNames.startDate")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productNames.endDate")}
            </TableCell>
            <TableCell sx={{ fontWeight: 600, fontSize: "0.8125rem", py: 1.5 }}>
              {t("productNames.vbnVersionDate")}
            </TableCell>
          </TableRow>
        </TableHead>
        <TableBody>
          {entityNamings && entityNamings.length > 0 ? (
            entityNamings.map((item, index) => (
              <TableRow
                key={`${item.itemCode ?? ""}-${item.secondItemCode ?? ""}-${item.languageCode ?? ""}-${item.nameType ?? ""}-${item.startDate ?? ""}-${index}`}
              >
                <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{item.languageCode ?? "-"}</TableCell>
                <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{item.nameType ?? "-"}</TableCell>
                <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{item.value ?? "-"}</TableCell>
                <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{formatDate(item.startDate)}</TableCell>
                <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{formatDate(item.endDate)}</TableCell>
                <TableCell sx={{ fontSize: "0.8125rem", py: 1.5 }}>{formatDateTime(item.vbnChangeDateTime)}</TableCell>
              </TableRow>
            ))
          ) : (
            <TableRow>
              <TableCell colSpan={6} sx={{ fontSize: "0.8125rem", py: 1.5 }}>
                {t("productNames.empty", { defaultValue: "Geen gegevens gevonden" })}
              </TableCell>
            </TableRow>
          )}
        </TableBody>
      </ResponsiveTable>
    </TableContainer>
  );
}
